(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-announcements"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var target = new Date('2026-10-19T00:00:00+03:00').getTime();

    function pad(value) {
      return String(value).padStart(2, '0');
    }

    function tick() {
      var el = document.querySelector('[class*="text-block--"][class*="announcement_sale"] .announcement-bar__text');
      if (!el) return;

      var remaining = target - Date.now();

      if (remaining <= 0) {
        el.textContent = 'Sale Has Ended';
        return;
      }

      var days = Math.floor(remaining / 86400000);
      var hours = Math.floor((remaining % 86400000) / 3600000);
      var minutes = Math.floor((remaining % 3600000) / 60000);
      var seconds = Math.floor((remaining % 60000) / 1000);

      function seg(value, unit) {
        return '<span class="announcement-bar__countdown-seg">' + pad(value) + '<small>' + unit + '</small></span>';
      }

      var segments = '';
      if (days > 0) segments += seg(days, 'd');
      segments += seg(hours, 'h') + seg(minutes, 'm') + seg(seconds, 's');

      el.innerHTML = 'Sale Ends In <span class="announcement-bar__countdown">' + segments + '</span>';
    }

    tick();
    setInterval(tick, 1000);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
